import React from 'react';
import ReactMarkdown from 'react-markdown';

import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import './blog-post.css';

export const BlogPost = ({ post }) => (
  <div className="blog-item-post">
    {post.category && (
      <p className="blog-item-post__category">{post.category.title}</p>
    )}
    <h1>{post.title}</h1>
    <p className="blog-item-post__date">{post.formattedPublishedAt}</p>
    <img
      src={`${post.coverImage.url}?w=600`}
      alt={post.coverImage.title}
      className="blog-item-post__cover-image"
    />

    <div className="blog-item-post__content">
      <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
        {post.post}
      </ReactMarkdown>
    </div>
  </div>
);
